/* ==========================================================================
   ROI TIME SAVINGS CALCULATOR LOGIC
   ========================================================================== */

export function initRoiCalculator() {
  const roleButtons = document.querySelectorAll('.role-btn');
  const hoursSlider = document.getElementById('hours-slider');
  const hoursDisplay = document.getElementById('hours-display');
  const savedHoursElement = document.getElementById('saved-hours-value');
  const monthlySavingsElement = document.getElementById('monthly-savings-value');
  const efficiencyPercentElement = document.getElementById('efficiency-percent');

  const calcCtaWhatsapp = document.getElementById('cta-calc-whatsapp');

  if (!hoursSlider || !savedHoursElement) return;

  // Default parameters by role
  const roleFactors = {
    professional: { savingRatio: 0.75, label: 'Profissionais & Especialistas' }, // 75% savings
    manager: { savingRatio: 0.80, label: 'Gestores & Líderes' },                 // 80% savings
    entrepreneur: { savingRatio: 0.73, label: 'Empreendedores' }                 // 73% savings
  };

  let activeRole = 'professional';

  const presetBtns = document.querySelectorAll('.preset-hour-btn');
  const profileCards = document.querySelectorAll('.roi-profile-card');

  function updateCalculations() {
    const currentHours = parseFloat(hoursSlider.value);
    const factor = roleFactors[activeRole].savingRatio;

    const savedWeeklyHours = Math.round(currentHours * factor);
    const savedMonthlyHours = Math.round(savedWeeklyHours * 4.33);
    const efficiencyPercent = Math.round(factor * 100);

    hoursDisplay.textContent = `${currentHours}h / semana`;
    savedHoursElement.textContent = `+${savedWeeklyHours}h`;
    monthlySavingsElement.textContent = `~${savedMonthlyHours}h economizadas por mês`;

    if (calcCtaWhatsapp) {
      const phoneMatch = calcCtaWhatsapp.href ? calcCtaWhatsapp.href.match(/wa\.me\/(\d+)/) : null;
      const phoneNumber = phoneMatch ? phoneMatch[1] : '5511930173654';
      const msg = encodeURIComponent(`Olá Diego! Simulei no site que posso economizar +${savedWeeklyHours}h por semana (~${savedMonthlyHours}h/mês) e gostaria de saber como automatizar minha rotina.`);
      calcCtaWhatsapp.href = `https://wa.me/${phoneNumber}?text=${msg}`;
    }

    // Sync Preset buttons active state
    presetBtns.forEach(btn => {
      if (parseFloat(btn.dataset.hours) === currentHours) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Sync Role buttons active state
    roleButtons.forEach(btn => {
      if (btn.dataset.role === activeRole) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Sync Profile cards active state
    profileCards.forEach(card => {
      if (card.dataset.roleSync === activeRole) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });
  }

  // Event Listeners for Role Selector Buttons
  roleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      activeRole = btn.dataset.role;
      updateCalculations();
    });
  });

  // Event Listeners for Profile Cards (Antes vs Depois)
  profileCards.forEach(card => {
    card.addEventListener('click', () => {
      activeRole = card.dataset.roleSync || 'professional';
      if (card.dataset.hoursPreset) {
        hoursSlider.value = card.dataset.hoursPreset;
      }
      updateCalculations();
    });
  });

  // Event Listeners for Quick Preset Hour Buttons
  presetBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      hoursSlider.value = btn.dataset.hours;
      updateCalculations();
    });
  });

  // Event Listener for Slider
  hoursSlider.addEventListener('input', updateCalculations);

  // Initial Calculation
  updateCalculations();
}
